import React from "react";
import { Button } from "@bandit-network/react-ui-kit";

const ModuleComplete = ({ onContinue }: { onContinue: () => void }) => {
  return (
    <div className="flex flex-col w-full h-full items-center justify-center">
      <img
        src="https://assets.bandit.network/assets/success-check-icon.svg"
        alt="success"
        className="w-24 h-24 mb-2"
      />
      <h4 className="text-xl font-medium">Congratulations 🎉</h4>
      <p className="mt-1">You have reached a new checkpoint!</p>
      <div className="flex items-center mt-2">
        <Button onClick={onContinue}>Continue</Button>
      </div>
    </div>
  );
};

export { ModuleComplete };
